import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./ResidentSidebar.css";

export default function ResidentSidebar() {
  const residentName = localStorage.getItem("residentName");
  const unitNumber = localStorage.getItem("unitNumber");
  const [open, setOpen] = useState(false);

  const navItems = [
    { to: "/resident/dashboard", label: "🏠 Dashboard" },
    { to: "/resident/payments", label: "💰 Payments" },
    { to: "/resident/visitor-approvals", label: "🚪 Visitor Approvals" },
    { to: "/resident/notices", label: "📢 View Notices" },
    { to: "/resident/maintenance", label: "🔧 Maintenance Requests" },
    { to: "/resident/rentals", label: "🏢 My Rentals" },
    { to: "/resident/vendors", label: "🏪 Vendor Directory" },
    { to: "/resident/theatre", label: "🎭 Mini Theatre" },
    { to: "/resident/profile", label: "👤 My Profile" },
  ];

  const closeDrawer = () => setOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("residentToken");
    localStorage.removeItem("residentName");
    localStorage.removeItem("unitNumber");
    localStorage.removeItem("residentStatus");
    localStorage.removeItem("residentTower");
    window.location.href = "/resident/login";
  };

  return (
    <>
      <div className="resident-mobile-bar hide-desktop">
        <button className="resident-hamburger" onClick={() => setOpen(true)} aria-label="Open menu">
          <span></span><span></span><span></span>
        </button>
        <span className="resident-mobile-title">Crown Residences</span>
      </div>

      {open && <div className="resident-drawer-backdrop hide-desktop" onClick={closeDrawer} />}

      <div className={`resident-sidebar ${open ? "open" : ""}`}>
        <button className="resident-drawer-close hide-desktop" onClick={closeDrawer} aria-label="Close menu">✕</button>

        <div className="resident-sidebar-header">
          <div>
            <h2>Crown Residences</h2>
            <div className="resident-identity">
              {residentName || "Resident"}{unitNumber ? ` · ${unitNumber}` : ""}
            </div>
          </div>
          <button
            className="resident-logout-header"
            onClick={handleLogout}
            title="Logout"
          >
            🚪
          </button>
        </div>

        <nav className="resident-sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={closeDrawer}
              className={({ isActive }) =>
                isActive ? "resident-nav-btn active" : "resident-nav-btn"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </>
  );
}